"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateUtagData = exports.countryUtagData = exports.cityUtagData = exports.brokerageUtagData = exports.agentUtagData = exports.agencyUtagData = void 0;
var agentUtagData = (props, env) => {
  return {
    page_category: 'Profile',
    page_name: 'Advisor Profile',
    site_id: 'MM-Advisor',
    advisor: "".concat(props.name)
  };
};
exports.agentUtagData = agentUtagData;
var agencyUtagData = (props, env) => {
  return {
    page_category: 'Directory',
    page_name: 'Agency Listing',
    site_id: 'MM-Advisor',
    agency: "".concat(props.name)
  };
};
exports.agencyUtagData = agencyUtagData;
var cityUtagData = (props, env) => {
  return {
    page_category: 'Directory',
    page_name: 'Agency Directory',
    site_id: 'MM-Advisor',
    state: "".concat(props.location.state),
    city: "".concat(props.location.city)
  };
};
exports.cityUtagData = cityUtagData;
var stateUtagData = (props, env) => {
  return {
    page_category: 'Directory',
    page_name: 'City Directory',
    site_id: 'MM-Advisor',
    state: "".concat(props.location.state)
  };
};
exports.stateUtagData = stateUtagData;
var countryUtagData = env => {
  return {
    page_category: 'Directory',
    page_name: 'State Directory',
    site_id: 'MM-Advisor'
  };
};
exports.countryUtagData = countryUtagData;
var brokerageUtagData = props => {
  return {
    page_category: 'Profile',
    page_name: 'Brokerage Director Profile',
    site_id: 'MM-BrokerageDirector',
    brokeragedirector: "".concat(props.name)
  };
};
exports.brokerageUtagData = brokerageUtagData;